/* Lo propio de tienda.rojo.me (Órbita trae orbita-web.js).
   Barra de compra fija (celular y escritorio): entra cuando la tarjeta de compra quedó arriba de la pantalla
   y sale cuando se ve el cierre, para que el botón «Inscribirme ahora» esté siempre a mano y nunca haya dos rojos a la vez. */
(function () {
  var barra = document.querySelector('[data-barra-compra]');
  var tarjeta = document.querySelector('.ob-compra');
  var cierre = document.querySelector('.ob-cierre-final');
  if (!barra || !tarjeta || !('IntersectionObserver' in window)) return;
  barra.hidden = false;
  var pasoTarjeta = false, veoCierre = false;
  function actualizar() {
    var ver = pasoTarjeta && !veoCierre;
    if (ver) barra.setAttribute('data-visible', ''); else barra.removeAttribute('data-visible');
    barra.inert = !ver;
  }
  new IntersectionObserver(function (e) {
    pasoTarjeta = !e[0].isIntersecting && e[0].boundingClientRect.top < 0; actualizar();
  }).observe(tarjeta);
  if (cierre) new IntersectionObserver(function (e) { veoCierre = e[0].isIntersecting; actualizar(); }).observe(cierre);
  actualizar();
})();
